import { storeToRefs } from 'pinia';
import { useWorkspaceAddAndEdit } from '@/dashboard/store/workspaceAddEditStore';
import { useAppStore } from '@/dashboard/store/appStore';
import { useAlertStore } from '@/dashboard/store/alertStore';
import { computed } from 'vue';
import { Workspace } from '@/dashboard/types/workspace';

export function openCreateWorkspace() {
  const appStore = useAppStore();
  const alertStore = useAlertStore();
  const workspaceAddAndEdit = useWorkspaceAddAndEdit();
  const { workspaces } = storeToRefs(appStore);
  const count = computed(() => {
    return (workspaces.value as Workspace[]).reduce((acc, cur) => {
      if (!cur.has_subscription && cur.owner_id === cur.user.id) acc++;
      return acc;
    }, 0);
  });

  if (count.value >= 3) {
    alertStore.open({ title: 'Workspace Limit Reached', subtitle: 'You can create up to 3 free workspaces.', okTitle: 'Ok' });
  } else {
    workspaceAddAndEdit.openPopup(true);
  }
}
